import { authApi } from '@/axios.config';
import { mockAdapter } from '@/mocks/axiosMockAdapter.config';

const allowEffect = 'Allow';
const denyEffect = 'Deny';
export const state = {
  permissions: [],
  enabledRbacSetting: false,
  policiesMap: {
    [allowEffect]: {},
    [denyEffect]: {},
  },
};

export const actions = {
  async getUserPermission({ commit, rootState }) {
    // ルートユーザーの場合はパーミッションチェックしない
    if (rootState.rootUser) return Promise.resolve();

    const url = 'me/permissions';

    mockAdapter(authApi, 'get', url, 'getPermissions', 200);

    const res = await authApi.get(url);

    commit('updatePermissions', res.data);
    commit('updateEnabledRbacSetting', res.data);
    commit('updatePoliciesMap', res.data);

    // Dev Tools
    commit('devTools/setPermissions', res.data, { root: true });
  },
};

export const mutations = {
  updatePermissions(state, data) {
    const productPermission = data.find(product => {
      return product.namespace === 'wave';
    });

    if (productPermission) {
      state.permissions = productPermission.permissions;
    }
  },

  updateEnabledRbacSetting(state, data) {
    const productPermission = data.find(product => {
      return product.namespace === 'user' || product.namespace === 'rbac';
    });

    if (productPermission) {
      if (productPermission.permissions.length > 0) {
        state.enabledRbacSetting = true;
      } else {
        state.enabledRbacSetting = false;
      }
    }
  },

  updatePoliciesMap(state, data) {
    const productPermission = data.find(product => {
      return product.namespace === 'wave';
    });

    if (!productPermission) {
      return;
    }

    let { policies } = productPermission;
    if (!policies) policies = [];

    const policiesMap = policies.reduce(
      (agg, { effect, action, key, values }) => {
        const mapKey = `${action}-${key}`;
        const valuesMap = values.reduce((agg, value) => {
          agg[value] = true;
          return agg;
        }, {});
        agg[effect] = {
          ...agg[effect],
          [mapKey]: {
            ...(agg[effect][mapKey] || {}),
            ...valuesMap,
          },
        };
        return agg;
      },
      { ...state.policiesMap }
    );
    state.policiesMap = policiesMap;
  },
};

export const getters = {
  enabledRbacSetting(state, _, rootState) {
    return rootState.rootUser ? true : state.enabledRbacSetting;
  },
  getPoliciesValuesMap: state => (effect, action, key) => {
    const mapKey = `${action}-${key}`;
    const { [mapKey]: valuesMap = {} } = state.policiesMap[effect];
    return valuesMap;
  },
  shouldResourcesBeFiltered: (_, getters) => (actions, key) => {
    return actions.every(action => {
      const valuesMap = getters.getPoliciesValuesMap(allowEffect, action, key);
      return Object.keys(valuesMap).length;
    });
  },
  isResourceAllowed: (_, getters) => (actions, key, value) => {
    return actions.some(action => {
      const valuesMap = getters.getPoliciesValuesMap(allowEffect, action, key);
      if (!Object.keys(valuesMap).length) {
        return true;
      }
      return valuesMap[value];
    });
  },
};
